import { render, staticRenderFns } from "./Expandable.vue?vue&type=template&id=97ef1e92&scoped=true&"
import script from "./Expandable.vue?vue&type=script&lang=ts&"
export * from "./Expandable.vue?vue&type=script&lang=ts&"
import style0 from "./Expandable.vue?vue&type=style&index=0&id=97ef1e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ef1e92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
